// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AdminCheckbox_checkbox__1jyL6","disabled":"AdminCheckbox_disabled__1guAB","checkmark":"AdminCheckbox_checkmark__16oBC","colorSquare":"AdminCheckbox_colorSquare__ugHJQ"};